// Imports
import Vue from "vue";
import Router from "vue-router";
import AuthGuard from "./auth-guard";
// import PreloadProfile from "./preload-profile";
import VueMeta from "vue-meta";
Vue.use(VueMeta);
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      component: () => import("@/layouts/home/Index.vue"),
      children: [
        {
          path: "",
          name: "Home 🏠",
          component: () => import("@/views/Index.vue")
        },
        {
          path: "about",
          name: "About 🙋‍♂️",
          component: () => import("@/views/about.vue")
          //  meta: { src: require("@/assets/about.jpg") }
        },
        {
          path: "items",
          name: "Items 📷",
          props: route => ({ category: route.query.category }),
          component: () => import("@/views/search.vue")
          //  meta: { src: require("@/assets/news.jpg") }
        },
        {
          path: '/groups/new',
          name: 'new-post',
          component: () => import('@/views/groups/NewPostPage.vue'),
        },
        {
          path: "inbox",
          name: "Inbox ✉️",
          component: () => import("@/views/inbox.vue")
          //  meta: { src: require("@/assets/news.jpg") }
        },
        {
          path: "url",
          name: "Upload Url ✉️",
          component: () => import("@/views/upload-url.vue")
          //  meta: { src: require("@/assets/news.jpg") }
        },
        {
          path: "algolia",
          name: "Algolia ✉️",
          component: () => import("@/views/algolia.vue")
          //  meta: { src: require("@/assets/news.jpg") }
        },
        {
          path: '/groups',
          name: 'groups',
          component: () => import("@/views/groups/groups.vue")
        },
        {
          path: '/group/:name',
          name: 'group',
          component: () => import("@/views/groups/group.vue")
        },
        {
          path: '/r/:name/:post_id',
          name: 'post',
          component: () => import("@/views/Post.vue")
        },
        {
          path: "items/new",
          name: "New Item ➕",
          component: () => import("@/views/add-item.vue")
        },
        {
          path: "sell/new",
          name: "New Sales Item ➕",
          component: () => import("@/views/add-sales-item.vue")
        },
        {
          path: "/items/:itemName",
          name: "Item",
          component: () => import("@/views/item.vue"),
          props: true
        },
        {
          path: "/items2/:itemName",
          name: "Item2",
          component: () => import("@/views/item2.vue"),
          props: true
        },
        {
          path: "/salesItems/:itemName",
          name: "salesItem",
          component: () => import("@/views/salesItem.vue"),
          props: true
        },

        {
          path: "/salesItemPurchase/:id",
          name: "salesItemPurchase",
          component: () => import("@/views/salesItemPurchase.vue"),
          props: true
        },
        {
          path: "/profile/:id",
          name: "Profile",
          component: () => import("@/views/profile.vue"),
          props: true
        },
        {
          path: "/upload",
          name: "upload",
          component: () => import("@/views/upload.vue"),
          props: true
        },
        {
          path: "/test",
          name: "test",
          component: () => import("@/views/test.vue"),
          props: true
        },
        {
          path: "/edit-profile",
          name: "Edit Profile",
          component: () => import("@/views/edit-profile.vue"),
          props: true
        },
        {
          path: "/avatar",
          name: "avatar",
          component: () => import("@/views/avatar.vue"),
          props: true
        },
        {
          path: "/signup",
          name: "landing",
          component: () => import("@/views/landing.vue"),
          props: true
        },
        {
          path: "/my/purchases/:id",
          name: "Purchase",
          component: () => import("@/views/purchase.vue"),
          props: true
        },
        {
          path: "/new/request",
          name: "New Request ✍️",
          component: () => import("@/views/newRequest.vue"),
          props: true
        },
        {
          path: "/map",
          name: "map",
          component: () => import("@/views/map.vue"),
          props: true
        },
        {
          path: "/join",
          name: "join",
          component: () => import("@/views/join.vue"),
          props: true
        },
        {
          path: "/client",
          name: "client",
          component: () => import("@/components/Client.vue"),
          props: true
        },
        {
          path: "/support",
          name: "support",
          component: () => import("@/views/support.vue"),
          props: true
        },
        {
          path: "/signup",
          name: "landing",
          component: () => import("@/views/landing.vue"),
          props: true
        },
        {
          path: "/onboarding",
          name: "Onboarding",
          component: () => import("@/views/onboarding.vue"),
          props: true,
        },
        {
          path: "/browse",
          name: "browse",
          component: () => import("@/views/search.vue"),
          props: true
        },

        {
          path: "/search",
          name: "search",
          component: () => import("@/views/search.vue"),
          props: true
        },
        {
          path: "/category/:id",
          name: "category",
          component: () =>
            import(/* webpackChunkName: "category" */ "@/views/category.vue")
        },
        {
          path: "/verify/:id",
          name: "Verify 📊",
          component: () => import("@/views/verify.vue"),
          props: true
        },
        {
          path: "/new/request",
          name: "New Request ✍️",
          component: () => import("@/views/newRequest.vue"),
          props: true
        },
        {
          path: "/item-requests",
          name: "Item Requests",
          component: () => import("@/views/itemRequests.vue"),
          props: true
        },
        {
          path: "/old-requests",
          name: "Old Requests",
          component: () => import("@/views/oldRequests.vue"),
          props: true
        },
        {
          path: "/booking/:id",
          name: "Booking",
          component: () => import("@/views/booking.vue"),
          props: true
        },
        {
          path: "return",
          name: "Return",
          component: () => import("@/views/return.vue"),
          props: route => ({ code: route.query.code }),
          props: true
        },
        {
          path: "dashboard",
          name: "Dashboard 📊",
          // props: route => ({ s: route.query.s }),
          component: () => import("@/views/dashboard.vue"),
          meta: { auth: true },
          props: true,
          // beforeEnter: AuthGuard
        },
        {
          path: "/reviews",
          name: "Reviews 📊",
          props: route => ({ s: route.query.s }),
          component: () => import("@/views/reviews.vue"),
          meta: { auth: true },
          // beforeEnter: AuthGuard
        },
        {
          path: "terms",
          name: "Terms and conditions 📄",
          component: () => import("@/views/terms.vue")
          //  meta: { src: require("@/assets/marketing.jpg") }
        },
        {
          path: "FAQ",
          name: "FAQs 📠",
          component: () => import("@/views/faq.vue")
          //  meta: { src: require("@/assets/marketing.jpg") }
        },
        {
          path: "privacy-policy",
          name: "Privacy Policy 📄",
          component: () => import("@/views/privacy-policy.vue")
          //  meta: { src: require("@/assets/marketing.jpg") }
        },

        {
          path: "contact-us",
          name: "Contact 📞",
          component: () => import("@/views/contact-us.vue")
          // meta: { src: require("@/assets/contact.jpg") }
        },

        {
          path: "kitchen-sink",
          name: "Sink",
          component: () => import("@/views/sink/Index.vue")
          // meta: { src: require("@/assets/sink.jpg") }
        },
        {
          path: "upload",
          name: "Upload",
          component: () => import("@/views/upload.vue")
          // meta: { src: require("@/assets/sink.jpg") }
        },
        {
          path: "select",
          name: "Select",
          component: () => import("@/views/selectScreen.vue")
        },
        {
          path: "stitch",
          name: "StrappStitch",
          component: () => import("@/views/stitch.vue")
          // meta: { src: require("@/assets/sink.jpg") }
        },
        {

          path: "*",
          name: "FourOhFour 😞",
          component: () => import("@/views/404.vue")
        },

      ]
    }
  ]
});

// router.beforeEach((to, from, next) => {
//   document.title = `${process.env.VUE_APP_TITLE} - ${to.name}`;
//   next();
// });

export default router;
